import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'includes' })
export class IncludesPipe implements PipeTransform {
  public transform(array: string[], value: string): boolean {
    return array.includes(value);
  }
}
